import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import I18n from 'I18n';
import AddDataSourceFilterRecordsByTypes from 'automation-ui-formula-editor/fetch-object-panel/constants/AddDataSourceFilterRecordsByTypes';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { MULTI_OBJECT_DATA_SOURCES } from 'automation-ui-formula-editor/constants/Gates';
import { selectRecordByOptions, SelectRecordBy } from 'automation-ui-formula-editor/fetch-object-panel/containers/fields/utils/selectRecordBy';
import { jsx as _jsx } from "react/jsx-runtime";
const AddDataSourceBasicSortBy = ({
  onSortByChange,
  selectRecordByValue,
  flowObjectTypeId,
  toObjectTypeId,
  recordFilterType,
  filterTargetType,
  isNewDataSource,
  readOnly
}) => {
  const isUngatedToMultiObjectDataSources = useIsUngated(MULTI_OBJECT_DATA_SOURCES);
  const options = selectRecordByOptions({
    flowObjectTypeId,
    objectTypeId: toObjectTypeId,
    recordFilterType,
    filterTargetType,
    isNewDataSource,
    isUngatedToMultiObjectDataSources
  });
  const supportsMultiObjectDataSources = recordFilterType === AddDataSourceFilterRecordsByTypes.ASSOCIATION_LABEL;
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.one-to-many-drop-down.title_cob",
      objectTypeId: toObjectTypeId
    }),
    required: !(isUngatedToMultiObjectDataSources && supportsMultiObjectDataSources),
    children: /*#__PURE__*/_jsx(UISelect, {
      "data-test-id": "select-record-by-dropdown",
      onChange: onSortByChange,
      options: options,
      value: selectRecordByValue !== null && selectRecordByValue !== void 0 ? selectRecordByValue : SelectRecordBy.NONE,
      placeholder: I18n.text('automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.one-to-many-drop-down.options-text.all.title'),
      readOnly: readOnly
    })
  });
};
export default AddDataSourceBasicSortBy;